import { useQuery } from "@apollo/client";
import { FETCH_SERVICE_JOBS } from "@services/graphql/queries/fetchServiceJobs";
import { ServiceCreditType, ServiceJobStatus, ServiceJob } from "@/app/graphql/codegen";

export const useVsmeJobs = () => {
    const {
        data: pendingData,
        loading: pendingLoading,
        error: pendingError,
        refetch: refetchPending,
    } = useQuery(FETCH_SERVICE_JOBS, {
        variables: { type: ServiceCreditType.VsmeReport, status: ServiceJobStatus.Pending },
        errorPolicy: "all",
    });

    const {
        data: completedData,
        loading: completedLoading,
        error: completedError,
        refetch: refetchCompleted,
    } = useQuery(FETCH_SERVICE_JOBS, {
        variables: { type: ServiceCreditType.VsmeReport, status: ServiceJobStatus.Completed },
        errorPolicy: "all",
    });

    return {
        pendingJobs: (pendingData?.serviceJobs || []) as ServiceJob[],
        completedJobs: (completedData?.serviceJobs || []) as ServiceJob[],
        loading: pendingLoading || completedLoading,
        error: pendingError || completedError,
        refetch: () => {
            refetchPending();
            refetchCompleted();
        },
    } as const;
}; 